import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Trophy, Heart } from "lucide-react";

const Donors = () => {
  const { t, lang } = useApp();
  const [donors, setDonors] = useState([]);
  const [stats, setStats] = useState({ total_amount: 0, total_donors: 0 });

  useEffect(() => {
    api.get("/donors/public").then((r) => setDonors(r.data)).catch(() => {});
    api.get("/donors/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="donors-page">
      <div className="mb-12 animate-fade-up">
        <p className="text-xs uppercase tracking-[0.25em] text-[#C95B24] font-semibold mb-3">{t("donors")}</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl text-[#1B4332] mb-4 leading-[1.05]">{t("donorsTitle")}</h1>
        <p className="text-lg text-[#4A4A4A]">{t("donorsSub")}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-14">
        <div className="card-tactile p-8 flex items-center gap-5">
          <div className="w-14 h-14 rounded-full bg-[#F4EFE6] flex items-center justify-center">
            <Heart className="w-6 h-6 text-[#C95B24]" />
          </div>
          <div>
            <div className="font-serif-display text-4xl text-[#1B4332]">{stats.total_donors}</div>
            <div className="text-sm uppercase tracking-[0.15em] text-[#4A4A4A]">{lang === "hi" ? "कुल दानदाता" : "Total Donors"}</div>
          </div>
        </div>
        <div className="card-tactile p-8 flex items-center gap-5">
          <div className="w-14 h-14 rounded-full bg-[#F4EFE6] flex items-center justify-center">
            <Trophy className="w-6 h-6 text-[#C95B24]" />
          </div>
          <div>
            <div className="font-serif-display text-4xl text-[#1B4332]">₹ {Number(stats.total_amount).toLocaleString("en-IN")}</div>
            <div className="text-sm uppercase tracking-[0.15em] text-[#4A4A4A]">{lang === "hi" ? "कुल संग्रह" : "Total Raised"}</div>
          </div>
        </div>
      </div>

      {donors.length === 0 ? (
        <div className="text-center py-20 text-[#4A4A4A]" data-testid="donors-empty">
          {lang === "hi" ? "अभी तक कोई सार्वजनिक दानदाता नहीं। सबसे पहले दानदाता बनने का सम्मान लें।" : "No public donors yet. Be the first to give with love."}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {donors.map((d, i) => (
            <div key={i} className="card-tactile p-6 flex items-center justify-between animate-fade-up" data-testid={`donor-card-${i}`}>
              <div>
                <div className="font-serif-display text-xl text-[#1B4332]">{d.name}</div>
                <div className="text-xs text-[#4A4A4A] mt-1">{d.purpose}</div>
              </div>
              <div className="text-[#C95B24] font-bold text-lg">₹ {Number(d.amount).toLocaleString("en-IN")}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Donors;
